<div class="text-center">
  <img src="../../../assets/images/reject.svg" />
  <div class="dialog-message">
    {{ data ? data.message : ('ERROR_DIALOG.MESSAGE' | translate) }}
    <a *ngIf="!data" href="mailto: support@payme.io">support@payme.io</a>
  </div>
</div>
